import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SubModule.style';
import { Provider } from '../../context/sub-module';

const SubModule = ({ disableAccordian, closed, children, className: classNameProp, ...other }) => {
  const className = clsx(styles.root, classNameProp);

  return (
    <Provider disableAccordian={disableAccordian} closed={closed}>
      <div className={className} {...other}>
        {children}
      </div>
    </Provider>
  );
};

SubModule.propTypes = {
  disableAccordian: PropTypes.bool,
  closed: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

SubModule.defaultProps = {
  disableAccordian: false,
  closed: false,
  className: '',
};

export default SubModule;
